export default __webpack_public_path__ + "static/media/popup_industry_stat_50.3046456b.png";